// extracted by mini-css-extract-plugin
export default {"bodyAndFooterContainer":"J_3wQ","moduleSwitcher":"IxVch"};